import Vue from 'vue'
import VueRouter from 'vue-router'
import PageBuilder from '../views/PageBuilder.vue'
import LayoutBuilder from '../views/LayoutBuilder.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'PageBuilder', component: PageBuilder},
  {path: '/layout', name: 'LayoutBuilder', component: LayoutBuilder},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
